import React from 'react';
import PropTypes from 'prop-types';
import DiscountTable from './discountTable';
import { useTranslation } from 'react-i18next';

export default function ManualForm({ onDiscounts, discountForm, discountErrors, discountId }) {
    const { discounts } = discountForm;
    const { t } = useTranslation();

    const handleChangeDiscount = React.useCallback(
        ({
            target: {
                value,
                name,
                dataset: { id }
            }
        }) => {
            let _tmpDiscounts = [...discounts];

            if (!_tmpDiscounts[+id]) {
                _tmpDiscounts[+id] = {
                    code: '',
                    quota: '',
                    name: ''
                };
            }
            _tmpDiscounts.splice(+id, 1, { ..._tmpDiscounts[+id], [name]: value });

            if (value === '') {
                if (Object.values(_tmpDiscounts[+id]).every(el => !el)) {
                    _tmpDiscounts.splice(+id, 1);
                }
            }
            onDiscounts('discounts', _tmpDiscounts);
        },
        [onDiscounts, discounts]
    );

    const discounts_list = React.useMemo(() => {
        if (discountId) {
            return [...discounts];
        }
        if (discounts.length < 100) {
            return [
                ...discounts,
                {
                    code: '',
                    quota: '',
                    name: ''
                }
            ];
        } else {
            return discounts;
        }
    }, [discounts, discountId]);

    const onPaste = React.useCallback(
        event => {
            event.preventDefault();
            let clip = event.clipboardData.getData('Text');
            let row = clip.split('\n');
            let rows = [];
            let tab_name = ['code', 'quota', 'name'];
            let paste_index = +event.target.dataset.id;
            let paste_name = event.target.name;

            paste_index = parseInt(paste_index);
            row.splice(100);

            row.forEach((r, row_number) => {
                if (!r || !r.trim() || !r.replace(/\t/g, '').trim()) {
                    return;
                }
                let index = tab_name.findIndex(name => name === paste_name);
                let existingData = [];
                if (discounts[parseInt(paste_index + row_number)] !== undefined) {
                    existingData = Object.values(discounts[paste_index + row_number]);
                }
                const pasted_data = r.split('\t');

                const pasted_length = pasted_data.length <= 4 ? pasted_data.length : 4;
                for (let i = 0; i < pasted_length; i++) {
                    existingData[index + i] = pasted_data[i];
                }
                rows.push(existingData);
            });

            let _tmpDiscounts = [...discounts];
            for (let i = 0; i < rows.length; i++) {
                const [code = '', quota = '', name = ''] = rows[i];
                _tmpDiscounts[i + paste_index] = {
                    code: code?.trim(),
                    quota: quota?.trim(),
                    name: name?.trim()
                };
            }

            onDiscounts('discounts', _tmpDiscounts);
        },
        [onDiscounts, discounts]
    );

    return (
        <>
            <DiscountTable
                discounts={discounts}
                discounts_list={discounts_list}
                onPaste={onPaste}
                handleChangeDiscount={handleChangeDiscount}
                discountErrors={discountErrors}
                discountId={discountId}
            />
            {`${discounts.length} ${t('ticket.common.discount', {
                count: discounts.length
            })}`}
        </>
    );
}

ManualForm.propTypes = {
    onDiscounts: PropTypes.func.isRequired,
    discounts: PropTypes.array.isRequired,
    discountErrors: PropTypes.object.isRequired,
    discountId: PropTypes.number
};
